/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ symbol: NonNullable<unknown> }} Components_Token_Icon_Symbol_Icon_AltInputs */

const en_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.symbol} icon`)
};

const de_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.symbol}-Symbol`)
};

const pt_br2_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ícone de ${i?.symbol}`)
};

const tr_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.symbol} simgesi`)
};

const zh_cn2_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.symbol} 图标`)
};

const zh_hk2_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.symbol} 圖示`)
};

const ko_kr2_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.symbol} 아이콘`)
};

const ru_ru2_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Иконка ${i?.symbol}`)
};

const es_419_components_token_icon_symbol_icon_alt = /** @type {(inputs: Components_Token_Icon_Symbol_Icon_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ícono de ${i?.symbol}`)
};

/**
* | output |
* | --- |
* | "{symbol} icon" |
*
* @param {Components_Token_Icon_Symbol_Icon_AltInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_token_icon_symbol_icon_alt = /** @type {((inputs: Components_Token_Icon_Symbol_Icon_AltInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Token_Icon_Symbol_Icon_AltInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_token_icon_symbol_icon_alt(inputs)
	if (locale === "de") return de_components_token_icon_symbol_icon_alt(inputs)
	if (locale === "pt-BR") return pt_br2_components_token_icon_symbol_icon_alt(inputs)
	if (locale === "tr") return tr_components_token_icon_symbol_icon_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_components_token_icon_symbol_icon_alt(inputs)
	if (locale === "zh-HK") return zh_hk2_components_token_icon_symbol_icon_alt(inputs)
	if (locale === "ko-KR") return ko_kr2_components_token_icon_symbol_icon_alt(inputs)
	if (locale === "ru-RU") return ru_ru2_components_token_icon_symbol_icon_alt(inputs)
	return es_419_components_token_icon_symbol_icon_alt(inputs)
});